import React from 'react';
import { Download, Share2 } from 'lucide-react';
import { MondrianButton } from './ui/MondrianButton';
import { MondrianPanel } from './ui/MondrianPanel';
import { MondrianGrid } from './MondrianGrid';
export function ShareCard() {
  return <div className="max-w-md mx-auto space-y-6" data-id="element-221">
      <div className="text-center space-y-2" data-id="element-222">
        <h2 className="text-2xl font-bold uppercase" data-id="element-223">分享你的作品</h2>
        <p className="text-gray-600" data-id="element-224">将你的新造型主义体验分享给世界</p>
      </div>

      <MondrianPanel className="space-y-4" borderWidth={8} data-id="element-225">
        {/* Card Content */}
        <div className="aspect-[4/5] bg-white flex flex-col gap-4" data-id="element-226">
          {/* Header */}
          <div className="flex justify-between items-end border-b-4 border-mondrian-black pb-2" data-id="element-227">
            <h3 className="font-bold text-xl" data-id="element-228">MONDRIAN LAB</h3>
            <span className="text-xs font-mono" data-id="element-229">2024.05.20</span>
          </div>

          {/* Main Art */}
          <div className="flex-1 border-4 border-mondrian-black relative" data-id="element-230">
            <MondrianGrid density="high" data-id="element-231" />
            <div className="absolute bottom-2 right-2 bg-white px-2 py-1 text-xs font-bold border-2 border-mondrian-black" data-id="element-232">
              GENERATED BY AI
            </div>
          </div>

          {/* Quote */}
          <div className="bg-gray-50 p-4 border-l-4 border-mondrian-yellow italic text-sm" data-id="element-233">
            "这幅作品展示了极佳的平衡感。你已经开始理解，去除表象之后，世界只剩下纯粹的关系。"
            <div className="text-right mt-2 font-bold not-italic" data-id="element-234">
              — P. Mondrian
            </div>
          </div>

          {/* Footer / QR */}
          <div className="flex gap-4 items-center pt-2" data-id="element-235">
            <div className="w-16 h-16 bg-mondrian-black flex items-center justify-center text-white text-xs text-center p-1" data-id="element-236">
              QR CODE
            </div>
            <div className="flex-1" data-id="element-237">
              <p className="font-bold text-sm" data-id="element-238">蒙德里安：现代艺术的几何美学</p>
              <p className="text-xs text-gray-500" data-id="element-239">扫描二维码体验数字实验室</p>
            </div>
          </div>
        </div>
      </MondrianPanel>

      <div className="flex gap-4" data-id="element-240">
        <MondrianButton variant="black" fullWidth className="flex justify-center items-center gap-2" data-id="element-241">
          <Download className="w-4 h-4" data-id="element-242" /> 保存图片
        </MondrianButton>
        <MondrianButton variant="yellow" fullWidth className="flex justify-center items-center gap-2" data-id="element-243">
          <Share2 className="w-4 h-4" data-id="element-244" /> 分享链接
        </MondrianButton>
      </div>
    </div>;
}